import { Helmet } from "react-helmet-async";
import { brandConfig } from "config/brandConfig";

type SEOMetaProps = {
  title: string;
  description: string;
  canonicalPath?: `/${string}`;
  index?: boolean;
  follow?: boolean;
};

export default function SEOMeta({
  title,
  description,
  canonicalPath,
  index = true,
  follow = true,
}: SEOMetaProps) {
  const canonicalUrl = canonicalPath
    ? `${brandConfig.NDD}${canonicalPath}`
    : undefined;
  const robotsContent = `${index ? "index" : "noindex"}, ${
    follow ? "follow" : "nofollow"
  }`;
  const ogImageUrl = `${brandConfig.NDD}${brandConfig.ogImage}`;

  return (
    <>
      <Helmet prioritizeSeoTags>
        <title>
          {title} - {brandConfig.brandName}
        </title>
        <meta name="description" content={description} />
        {index && canonicalPath && <link rel="canonical" href={canonicalUrl} />}
        <meta name="robots" content={robotsContent} />

        {/* Open Graph */}
        <meta
          property="og:title"
          content={`${title} - ${brandConfig.brandName}`}
        />
        <meta property="og:description" content={description} />
        {index && canonicalUrl && (
          <meta property="og:url" content={canonicalUrl} />
        )}
        <meta property="og:type" content="website" />
        <meta property="og:image" content={ogImageUrl} />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${title} - ${brandConfig.brandName}`}
        />
        <meta name="twitter:description" content={description} />
        <meta name="twitter:image" content={ogImageUrl} />
      </Helmet>
    </>
  );
}
